export default __webpack_public_path__ + "static/media/icon_home_top_base_mobile.dada428d.svg";